// removed by extract-text-webpack-plugin
module.exports = {"desktop":"1366px","large":"1600px"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/foundations/Grids/RightSection.css
// module id = 799
// module chunks = 0